<div class="p-4">
  <div class="sm:flex items-center justify-between my-4">
    <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">My Assigned Assets</span>
  </div>

  <div class="overflow-x-auto whitespace-nowrap hide-scrollbar">
    <table class="w-full table border border-[#D9D9D9] border-separate border-spacing-0 bg-white overflow-hidden">
      <thead class="bg-[#F2F2F2] text-444 text-xs sm:text-sm lg:text-base">
        <tr class="bg-gray-100">
          <th class="p-3 font-medium border-r border-444 last:border-r-0">Sr. No.</th>
          <th class="p-3 font-medium border-r border-444 last:border-r-0">Asset Name</th>
          <th class="p-3 font-medium border-r border-444 last:border-r-0">Status</th>
          <th class="p-3 font-medium last:border-r-0">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="isLoading">
          <td colspan="4" class="py-4 px-2 text-center text-gray-500">Loading assets...</td>
        </tr>
        <tr *ngIf="!isLoading && assignedAssets.length === 0">
          <td colspan="4" class="py-4 px-2 text-center text-gray-500">You have no assets assigned to you.</td>
        </tr>

        <tr *ngFor="let asset of assignedAssets; let i = index" class="text-xs sm:text-sm lg:text-[15px] text-444 odd:bg-white even:bg-gray-50">
          <td class="py-2 px-2 text-center border-t border-[#d9d9dd]">{{ i + 1 }}</td>
          <td class="py-2 px-2 text-center border-t border-[#d9d9dd]">{{ asset.name }}</td>

          <td class="py-2 px-2 text-center border-t border-[#d9d9dd]">
            <span *ngIf="asset.return_requested_at" class="px-2 py-1 font-semibold leading-tight text-blue-700 bg-blue-100 rounded-full">
              Return Requested
            </span>
            <span *ngIf="!asset.return_requested_at && asset.issue_reported_at && !asset.receipt_acknowledged_at" class="px-2 py-1 font-semibold leading-tight text-red-700 bg-red-100 rounded-full">
              Not Received
            </span>
            <span *ngIf="!asset.return_requested_at && asset.receipt_acknowledged_at" class="px-2 py-1 font-semibold leading-tight text-green-700 bg-green-100 rounded-full">
              Received on {{ asset.receipt_acknowledged_at | date:'dd-MMM-yyyy' }}
            </span>
            <span *ngIf="!asset.return_requested_at && !asset.receipt_acknowledged_at && !asset.issue_reported_at" class="px-2 py-1 font-semibold leading-tight text-yellow-700 bg-yellow-100 rounded-full">
              Pending
            </span>
          </td>

          <td class="py-2 px-2 text-center border-t border-[#d9d9dd]">
            <ng-container *ngIf="!asset.receipt_acknowledged_at && !asset.return_requested_at">
              <div class="flex items-center justify-center gap-2">
                <button (click)="acknowledgeReceipt(asset.id)" class="px-3 py-1 text-xs font-medium text-white bg-green-600 rounded-lg hover:bg-green-700">
                  Accept Asset
                </button>
                <button (click)="reportNotReceived(asset)" class="px-3 py-1 text-xs font-medium text-white bg-red-600 rounded-lg hover:bg-red-700">
                  Not Received
                </button>
              </div>
            </ng-container>

            <ng-container *ngIf="asset.receipt_acknowledged_at && !asset.return_requested_at">
              <button (click)="requestReturn(asset.id)" class="px-3 py-1 text-xs font-medium text-white bg-orange-500 rounded-lg hover:bg-orange-600">
                Request Return
              </button>
            </ng-container>

            <ng-container *ngIf="asset.return_requested_at">
              <span class="text-gray-400 text-xs">Awaiting admin approval</span>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
